"use client";
import { useState } from "react";
import Image from "next/image";

function Placeholder({ className }) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 bg-warm-white ${className}`}
    />
  );
}

// Delays image network request until shouldLoad is true
export default function LazyLoadImage({
  shouldLoad,
  className = "",
  alt = "",
  ...props
}) {
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  // Image stays mounted permanently to prevent flicker on re-open
  // Trade-off: increased memory usage for visited categories
  if (shouldLoad && !hasLoadedOnce) {
    setHasLoadedOnce(true);
  }

  if (!hasLoadedOnce) {
    return <Placeholder className={className} />;
  }

  return <ActiveImage className={className} alt={alt} {...props} />;
}

function ActiveImage({ className, alt, ...props }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {!isLoaded && <Placeholder className={className} />}
      <Image
        {...props}
        alt={alt}
        className={className}
        onLoad={() => setIsLoaded(true)}
      />
    </>
  );
}
